"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var houston_styles_1 = tslib_1.__importStar(require("@eduzz/houston-styles"));
var nestedComponent_1 = tslib_1.__importDefault(require("../utils/nestedComponent"));
var context_1 = tslib_1.__importDefault(require("./context"));
var Item_1 = tslib_1.__importDefault(require("./Item"));
var Left_1 = tslib_1.__importDefault(require("./Left"));
var Right_1 = tslib_1.__importDefault(require("./Right"));
var Text_1 = tslib_1.__importDefault(require("./Text"));
var List = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.dividers, dividers = _b === void 0 ? false : _b, rest = tslib_1.__rest(_a, ["children", "className", "dividers"]);
    return ((0, jsx_runtime_1.jsx)(context_1.default, tslib_1.__assign({ dividers: dividers }, { children: (0, jsx_runtime_1.jsx)("ul", tslib_1.__assign({ role: 'list', className: (0, houston_styles_1.cx)(className, { 'hst-list-dividers': dividers }) }, rest, { children: children })) })));
};
var ListWrapper = React.memo((0, houston_styles_1.default)(List, { label: 'hst-list' })(function () { return (0, houston_styles_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      &.hst-list-dividers {\n        hr:last-of-type {\n          display: none;\n        }\n      }\n    "], ["\n      &.hst-list-dividers {\n        hr:last-of-type {\n          display: none;\n        }\n      }\n    "]))); }));
/**
 * @deprecated Use List from Antd
 * https://ant.design/components/list/
 */
exports.default = (0, nestedComponent_1.default)(ListWrapper, {
    Item: Item_1.default,
    Text: Text_1.default,
    Left: Left_1.default,
    Right: Right_1.default
});
var templateObject_1;
